<template>
  <div>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="catalogs"
      :items-per-page="10"
      :sort-by="['mode.id', 'cardModel.description', 'catalogType.description']"
      :sort-desc="[false, false, false]"
      @click:row="(item) => openEditDialog(item)"
      :class="disableClick ? '' : 'table-cursor'"
    >
      <template v-slot:[`item.price`]="{ item }">
        {{
          Intl.NumberFormat(locale, {
            style: "currency",
            currency: item.currency,
          }).format(item.price)
        }}
      </template>
      <template v-slot:[`item.reversion`]="{ item }">
        {{
          Intl.NumberFormat(locale, {
            style: "currency",
            currency: item.currency,
          }).format(item.reversion)
        }}
      </template>
      <template v-slot:[`item.mode.id`]="{ item }">
        {{ item.mode.id == 0 ? "BASIC" : "FULL" }}
      </template>
    </v-data-table>
    <edit-catalog-dialog
      :partner="partner"
      :catalog="editedItem"
      :open.sync="openDialog"
      v-if="openDialog"
    ></edit-catalog-dialog>
  </div>
</template>
<script>
import { ref, computed } from "@vue/composition-api";
import { useCatalogs } from "@/composables/catalog";
import EditCatalogDialog from "@/components/Catalog/EditCatalogDialog";

export default {
  props: {
    catalogs: Array,
    partner: Object,
    isLoading: Boolean,
    firstLoad: Boolean,
    disableClick: Boolean,
  },
  components: {
    EditCatalogDialog,
  },
  setup(props) {
    /* Import des API */
    const { deleteCatalog, catalogData } = useCatalogs();

    /* Variables */
    const editedItem = ref({});
    const locale = ref("fr-FR");

    /* Computed */
    const openDialog = computed({
      get: function () {
        return catalogData.editCatalogDialog;
      },
      set: function (value) {
        catalogData.editCatalogDialog = value;
      },
    });

    /* Méthodes */
    const openEditDialog = function (item) {
      if (!props.disableClick) {
        editedItem.value = { ...item };
        catalogData.editCatalogDialog = true;
      }
    };

    return {
      headers: [
        { text: "Prix", value: "price" },
        { text: "Réversion", value: "reversion" },

        { text: "Mode", value: "mode.id" },
        { text: "Modèle", value: "cardModel.description" },
        { text: "Type", value: "catalogType.description" },
        {
          text: "Nb sessions simultanées",
          value: "cardModel.simultaneousSessionsNum",
        },
      ],
      deleteCatalog,
      editedItem,
      openEditDialog,
      openDialog,
      locale,
    };
  },
};
</script>
